import React from 'react';
import "./AnnotationDivider.css";

const AnnotationDivider = ({ timeline, formatSectionHeaderStr, formatTime }) => {
  return (
    <div className="annotation-section-divider">
      <span className="annotation-section-divider-label">
        <span dangerouslySetInnerHTML={{ __html: formatSectionHeaderStr(timeline.timeline) }}></span>
        <span> [{formatTime(timeline.frames[0].in)}]</span>
      </span>
      <span className="annotation-section-divider-line"></span>
    </div>
  )
}

export default AnnotationDivider;